import {Component, inject, Input} from '@angular/core';
import {DHLTrackingStatus} from '../../../../../Api/DcoApi/AktenEintraege/DHLTrackingStatus';
import {ExportPopup} from '../../../Status/ExportPopup';
import {StatusModel} from '../../../../../Api/DcoApi/Status/StatusModel';
import { VersandService } from "../../../../Services/VersandService";
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'dhl-controlls',
  imports: [CommonModule,FormsModule],
  templateUrl: './dhl-controlls.html',
  styleUrl: './dhl-controlls.css',
})
export class DhlControlls {
  @Input() TrackingNumber?: string ;
  @Input() IstVersand: boolean = true;
  @Input() AuftragKey?: number ;
  @Input() DCOAuftragKey: number = 0;
  @Input() MailAddress?: string ;
  @Input() ReloadData = () => {};

  VersandService : VersandService = inject(VersandService);
  async InitTracking() {

    var key  = this.AuftragKey;
    if(key)
      await this.VersandService.InitTracking(key);
    else
      await this.VersandService.InitTrackingForOrder(this.DCOAuftragKey, this.IstVersand);
    this.triggerReload();
  }


  async ResetTracking()
  {
    if(this.AuftragKey)
    {
      await  this.VersandService.ResetTracking(this.AuftragKey);
      this.triggerReload();
    }

  }

  hasTracking(): boolean {
    return this.TrackingNumber != undefined && this.TrackingNumber != null && this.TrackingNumber != '';
  }

  DownloadFile()
  {
    if(this.TrackingNumber != undefined && this.TrackingNumber != null && this.TrackingNumber != '')
      this.VersandService.downloadFileWithToken(this.TrackingNumber);
  }

  DownloadQrFile()
  {
    if(this.TrackingNumber != undefined && this.TrackingNumber != null && this.TrackingNumber != '')
      this.VersandService.downloadFileWithToken(this.TrackingNumber,true)
  }

  async openSendDialog() {

    await this.VersandService.openSendDialog( (this.TrackingNumber) ?? "", this.MailAddress ?? "",this.IstVersand)
    this.triggerReload();
  }

  triggerReload = () => {
    if(this.ReloadData)
      this.ReloadData();
  }

}
